import { type ReactNode } from 'react'

import { useTranslation } from 'react-i18next'

import { IconPin } from 'assets/svg/sprite'

import styles from './postInfoTop.module.scss'

interface Props {
    pinned: boolean
    live: boolean
    liveEnded: boolean
    customClass?: string
    isPendingReview?: boolean
    replayGraphButton?: ReactNode
}

export const PostInfoTop = ({
    pinned,
    live,
    liveEnded,
    customClass,
    isPendingReview,
    replayGraphButton
}: Props) => {
    const { t } = useTranslation()

    return (
        <div
            className={`${styles.wrapper} ${
                customClass === 'preview' ? styles.preview : ''
            }`}
        >
            {live && (
                <div className={`${styles.info} ${styles.live}`}>
                    <p>{t('live')}</p>
                </div>
            )}

            {isPendingReview && (
                <div className={styles.info}>
                    <p>Pending Review</p>
                </div>
            )}

            {!!pinned && (
                <div className={styles.info}>
                    <IconPin />
                    <p>{t('pinned')}</p>
                </div>
            )}

            {liveEnded && (
                <div className={styles.info}>
                    <p>{t('liveStreamEnded')}</p>
                </div>
            )}

            {replayGraphButton && (
                <div className={styles.replayGraphButton}>
                    {replayGraphButton}
                </div>
            )}
        </div>
    )
}